// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/cropperjs/dist/cropper.css
// module id = 254
// module chunks = 2